import { useState } from "react";

import Footer from "../components/Footer";
import Header from "../components/Header/Header";
import Main from "../components/Main";

function MainPage() {
  const [headerBg, setHeaderBg] = useState({ backgroundColor: "transparent" });

  return (
    <div className="App">
      <Header bgColor={headerBg} />
      <Main setHeaderBg={setHeaderBg} />
      <Footer />
    </div>
  );
}

export default MainPage;
